import _ from "lodash";
import { Form, getIn } from "formik";
import { Link } from "react-router-dom";
import React, { Component } from "react";
import Select from "react-select";

import { adminRequests } from "@/api/(requests)/admin";

import Button from "../../../components/UI/Button";
import { CardPrimary } from "../../../components/UI/Card";
import { CustomForm } from "../../../component-library/CustomForm";
import FormikInput from "../../../components/UI/FormikInput";
import images from "../../../utils/images";
import InputError from "../../../components/UI/InputError";
import Label from "../../../components/UI/Label";

import {
  PRACTICE_INITIAL_VALUES,
  PRACTICE_VALIDATION_SCHEMA,
  PRACTICE_SCHEMA,
} from "./schema/newPractice";

class NewPractice extends Component {
  state = {
    intakeProviderOptions: [],
  };
  async componentDidMount() {
    const searchParams = { providerTypes: "BEHAVIORAL_INTAKE" };

    try {
      const response = await adminRequests.fetch_providers({ searchParams });
      const intakeProviderOptions = response.map((provider) => {
        return {
          label: provider["name"] + " - " + provider["practice"],
          value: provider["username"],
        };
      });

      this.setState({ intakeProviderOptions });
    } catch (e) {
      console.log(e);
    }
  }

  setHcpAndSpmiForPracticeObject = (formData) => {
    let newFormData = _.cloneDeep(formData);

    if ("practice_specialization" in newFormData) {
      const specialization = newFormData.practice_specialization;

      if (specialization.toLowerCase() === "hcp") {
        newFormData.hcp_searchable = true;
        newFormData.is_spmi = false;
      } else if (specialization.toLowerCase() === "spmi") {
        newFormData.hcp_searchable = false;
        newFormData.is_spmi = true;
      } else if (specialization.toLowerCase() === "none" || _.isNil(specialization)) {
        newFormData.hcp_searchable = false;
        newFormData.is_spmi = false;
      }

      delete newFormData.practice_specialization;
    }

    return newFormData;
  };

  submitHandler = async (formData, actions) => {
    actions.setSubmitting(false);
    try {
      if (!formData["fax_number"]) {
        formData["fax_number"] = "None";
      }
      formData["additional_providers"] = [];
      formData["intake_provider_ids"] = formData["intake_provider_ids"]
        ? formData["intake_provider_ids"].map((option) => option.value)
        : null;
      let response = await adminRequests.post_practice({
        data: this.setHcpAndSpmiForPracticeObject(formData),
      });

      this.props.history.push("/app/practice");
    } catch (e) {
      console.log(e);
    }
  };

  renderForm = (formikProps) => {
    return (
      <Form>
        <div className="mx-auto px-0">
          <div className="container">
            <div className="mx-auto px-0">
              <div className="container">
                <div className="row">
                  {PRACTICE_SCHEMA.map((formEl) => {
                    const testId = `NewPracticeInfo_${formEl.name}`;

                    if (formEl.elementType === "segment") {
                      return (
                        <h6 className="col-12" key={formEl.displayName}>
                          <b>{formEl.displayName}</b>
                        </h6>
                      );
                    } else if (formEl.name === "intake_provider_ids") {
                      const error = getIn(formikProps.errors, formEl.name);
                      const touched = getIn(formikProps.touched, formEl.name);

                      return (
                        <>
                          {formikProps.values["practice_type"] === "Primary Care" && (
                            <div className="col-12 col-lg-6" key={formEl.name}>
                              <Label>{formEl.elementConfig.label}</Label>
                              <Select
                                className="basic-multi-select"
                                classNamePrefix="select"
                                components={{
                                  ClearIndicator: null,
                                }}
                                defaultValue={this.state.intakeProviderOptions.filter((option) =>
                                  formikProps.values[formEl.name].includes(option.value),
                                )}
                                isMulti
                                onChange={async (selectedOptions) =>
                                  await formikProps.setFieldValue(
                                    formEl.name,
                                    selectedOptions ? selectedOptions : [],
                                  )
                                }
                                options={this.state.intakeProviderOptions}
                              />
                              {error && touched ? (
                                <InputError classes="custom-error">{error}</InputError>
                              ) : null}
                            </div>
                          )}
                        </>
                      );
                    } else {
                      return (
                        <div className="col-12 col-lg-6" key={formEl.name}>
                          <FormikInput
                            errors={formikProps.errors}
                            formEl={formEl}
                            testId={testId}
                            touched={formikProps.touched}
                          />
                        </div>
                      );
                    }
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-lg-end tw:justify-center">
          <Button
            className="Btn Btn--otl-pri Btn-sm mr-3"
            onClick={() => this.props.history.push("/app/practice")}
            type="button"
          >
            Cancel
          </Button>
          <Button className="Btn Btn--pri Btn-sm" type="submit">
            Add Practice
          </Button>
        </div>
      </Form>
    );
  };

  render() {
    return (
      <div>
        <div className="survey-back-link-wpr mx-auto fs-16 my-3 py-2">
          <Link className="survey-back-link" to="/app/practice">
            <img className="img-fluid" src={images("./common/solidBckBtn.svg")} />
            <p className="d-inline ml-2">Back to Practice List</p>
          </Link>
        </div>
        <CardPrimary className="mx-auto" style={{ marginTop: 0 }}>
          <div>
            <CustomForm
              initialValues={PRACTICE_INITIAL_VALUES}
              onSubmit={this.submitHandler}
              render={this.renderForm}
              validationSchema={PRACTICE_VALIDATION_SCHEMA}
            />
          </div>
        </CardPrimary>
      </div>
    );
  }
}

export default NewPractice;
